import { reducerTypes } from './types';

export const setSelectedLanguageAction = (data: string) => ({
  type: reducerTypes.SET_SELECTED_LANGUAGE,
  payload: data,
});
